import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';


export const TermHighlighter = Extension.create({
    name: 'termHighlighter',

    addOptions() {
        return {
            termsStore: null,
        };
    },

    addProseMirrorPlugins() {
        let selectedEntries = new Set();
        let termEntries = new Map();
        let claimsModifiedSinceHeavyRefresh = false;
        let unsubscribe;

        return [
            new Plugin({
                key: new PluginKey('termHighlighter'),
                view: () => {
                    unsubscribe = this.options.termsStore.subscribe(store => {
                        selectedEntries = store.selectedEntries;
                        termEntries = store.termEntries;
                        claimsModifiedSinceHeavyRefresh = store.claimsModifiedSinceHeavyRefresh || false;
                    });

                    return {
                        destroy() {
                            unsubscribe?.();
                        }
                    };
                },
                props: {
                    decorations: (state) => {
                        if (!selectedEntries || selectedEntries.size === 0) {
                            return DecorationSet.empty;
                        }

                        // Don't show highlights when claims have been modified since last heavy refresh
                        // This prevents misaligned highlights when positions are stale
                        if (claimsModifiedSinceHeavyRefresh) {
                            console.log('[TipTap] Skipping highlights - claims modified since heavy refresh');
                            return DecorationSet.empty;
                        }

                        const decorations = [];
                        const doc = state.doc;

                        console.log('[TipTap] Selected entries:', Array.from(selectedEntries));

                        // Collect all terms to highlight
                        const termsToHighlight = new Set();
                        
                        selectedEntries.forEach(indexedKey => {
                            const termData = termEntries.get(indexedKey);
                            if (!termData) return;
                            
                            // Skip highlighting if term needs refresh
                            if (termData.needs_refresh) {
                                console.log(`[TipTap] Skipping highlight for "${termData.parent_term}" - needs refresh`);
                                return;
                            }
                            
                            // Add parent term
                            termsToHighlight.add(termData.parent_term);
                            
                            // Add child terms
                            if (termData.children && typeof termData.children === 'object') {
                                Object.keys(termData.children).forEach(childTerm => {
                                    termsToHighlight.add(childTerm);
                                });
                            }
                        });

                        // Search for terms by traversing text nodes (similar to SearchHighlighter)
                        termsToHighlight.forEach(term => {
                            const termLower = term.toLowerCase();
                            
                            doc.descendants((node, pos) => {
                                if (node.isText) {
                                    const nodeText = node.text;
                                    const nodeLower = nodeText.toLowerCase();
                                    
                                    // Find all word boundary matches in this text node
                                    const termRegex = new RegExp(`\\b${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
                                    let match;
                                    
                                    while ((match = termRegex.exec(nodeText)) !== null) {
                                        const from = pos + match.index;
                                        const to = pos + match.index + match[0].length;
                                        
                                        try {
                                            decorations.push(
                                                Decoration.inline(from, to, {
                                                    class: 'tt-highlighted-term'
                                                })
                                            );
                                            
                                            console.log(`[TipTap] Highlighting '${term}' at positions ${from}-${to}: "${match[0]}"`);
                                        } catch (error) {
                                            console.warn(`[TipTap] Failed to create decoration for '${term}' at ${from}-${to}:`, error);
                                        }
                                    }
                                }
                            });
                        });

                        return DecorationSet.create(doc, decorations);
                    }
                }
            })
        ];
    }
});

